var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHockey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.4,
    cy: 23.1,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,94.1L45.7,57.8c-2.3,2.3-3.4,5.2-3.4,8.2v26.6H16.6c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1h30.9 c2.8,0,5.1-2.3,5.1-5.1V79.3l20.6,20.6v28.7c0,2.8,2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1V97.7C83.4,96.3,82.9,95,82,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,117.8l-1.9,1.9c-0.7,0.7-1.7,1.1-2.7,1.1c-1,0-2-0.4-2.7-1.1L86.8,82.4c0.5-0.9,0.7-2,0.6-3c0-0.1,0-0.3,0-0.4V37.8 c0-5-4-9-9-9c-2.5,0-4.7,1-6.4,2.6L49.3,54.2c0,0,29.2,29.3,29.3,29.3c1.7,1.7,4.2,2,6.2,0.8l37.2,37.2c1.2,1.2,2.9,1.9,4.6,1.9 c1.7,0,3.4-0.7,4.6-1.9l1.9-1.9L131.2,117.8z M79.9,67.6l-7.8-7.8l7.8-7.8V67.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockey);
export default __webpack_public_path__ + "static/media/hockey.4ebad38e9b4f1b51dbb5cc61df980eaf.svg";
export { ForwardRef as ReactComponent };